import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    if (typeof HTMLDialogElement === 'function') {
      this.element.classList.add('supports_dialog')
    }
  }
}
